.overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: white;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid var(--color-black-10);
  flex-shrink: 0;
  min-height: 56px;
  position: relative;
}

.title {
  font-family: var(--font-condensed-bold, sans-serif);
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: #000;
  letter-spacing: 0;
}

.cancel {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--font-condensed-bold, sans-serif);
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: #000;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 0;
  line-height: 1;
}

.content {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 8px 0;
}

/* ── Closed-state trigger ─────────────────── */
.trigger {
  position: relative;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid var(--color-black-10);
  border-radius: var(--border-radius);
  padding: 0 16px 0 51px;
  background: white;
  font-size: 16px;
  font-weight: 500;
  user-select: none;
}

.triggerIcon {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  pointer-events: none;
}

.triggerValue {
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.triggerPlaceholder {
  color: var(--color-black-30);
}
